// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/confirm/{id}
 *
 * No body; the order id arrives as a URL path segment.
 */
import { registerContract } from './validate'

export interface Orders_ConfirmInput {}

registerContract('Orders_ConfirmInput', {})
